<template>
  <material-card
    :title="$t('components.employers.employer_details.contributions')"
    :color="$vuetify.theme.themes.light.primary"
    icon="card_membership"
  >
    <v-card-text>
      <template v-if="summaries !== null && summaries !== undefined">
        <div class="row no-gutters">
          <div class="col-12 col-md-3 col-lg-3 col-xl-2">
            <v-icon>sum</v-icon>
            {{
              $t(
                "components.employers.employers_contributions_table.total_summary"
              )
            }}
          </div>
          <div class="col-12 col-md-3 col-lg-3 col-xl-2">
            {{ $t("headers.employer_contributions.dues") }}
            <br />
            <span class="minfo">
              {{ $helpers.formatCurrency(summaries.Dues) }}
            </span>
          </div>
          <div class="col-12 col-md-3 col-lg-3 col-xl-2">
            {{ $t("components.claims_history.header.paid") }}
            <br />
            <span class="minfo">
              {{ $helpers.formatCurrency(summaries.Paid) }}
            </span>
          </div>
          <div class="col-12 col-md-3 col-lg-3 col-xl-2">
            {{
              $t(
                "components.employers.employers_contributions_table.total_balance"
              )
            }}
            <br />
            <span class="minfo">
              {{ $helpers.formatCurrency(summaries.Balance) }}
            </span>
          </div>
        </div>
      </template>
      <v-expansion-panels style="margin-top:10px">
        <v-expansion-panel>
          <v-expansion-panel-header class="v-card__title">
            <div class="row no-gutters">
              <div class="col">
                <v-icon class="member-expansion-panel-header-icon">
                  schedule
                </v-icon>
                <span class="member-expansion-panel-header">
                  {{
                    $t(
                      "components.employers.employers_contributions_table.terms_summary"
                    )
                  }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <employer-contributions-table :employerId="employerId" />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="v-card__title">
            <div class="row no-gutters">
              <div class="col">
                <v-icon class="member-expansion-panel-header-icon">
                  schedule
                </v-icon>
                <span class="member-expansion-panel-header">
                  {{ $t("globals.history") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <employer-contributions-history-table
              :employerId="employerId"
              :hasLocations="hasLocations"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import getHeaders from "@/headers/EmployerContributions";
import EmployerContributionsTable from "@/components/Employers/EmployerContributionsTable.vue";
import EmployerContributionsHistoryTable from "@/components/Employers/EmployerContributionsHistoryTable.vue";
export default {
  props: ["employerId", "hasLocations"],
  components: {
    ErrorHandler,
    EmployerContributionsTable,
    EmployerContributionsHistoryTable,
  },
  data() {
    return {
      error: null,
      summaries: null,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", ["getEmployerContributionSummaries"]),
    async loadPlanData() {
      try {
        this.summaries = (await this.getEmployerContributionSummaries({
          planIdentityId: this.selectedPlan.Id,
          employerIdentityId: this.employerId,
        })).data;
      } catch (error) {
        this.error = error;
        this.summaries = {
          Dues: 23450.0,
          Paid: 23000.0,
          Balance: -3450.0,
        };
        console.log(this.summaries);
      }
    },
  },
};
</script>
